"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_rnd_1 = require("react-rnd");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
// eslint-disable-next-line import/no-cycle
const actions_1 = require("~/store/actions");
// eslint-disable-next-line import/no-cycle
const selectors_1 = require("~/store/selectors");
const consts_1 = require("./consts");
const WidgetResizeIcon_1 = __importDefault(require("./WidgetResizeIcon"));
const Widget_module_scss_1 = __importDefault(require("./Widget.module.scss"));
function Widget({ widgetName, children, defaultPosition, defaultSize, minSize }) {
    var _a, _b;
    const rndRef = (0, react_1.useRef)(null);
    const { dispatchLiftUpWidget, dispatchUpdateWidgetPosition, dispatchUpdateWidgetSize } = (0, redux_1.bindActionCreators)({
        dispatchLiftUpWidget: actions_1.liftUpWidget,
        dispatchUpdateWidgetPosition: actions_1.updateWidgetPosition,
        dispatchUpdateWidgetSize: actions_1.updateWidgetSize,
    }, (0, react_redux_1.useDispatch)());
    const isWidgetActive = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetIsActive)(widgetName));
    const { restored, position, size, show } = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetState)(widgetName));
    (0, react_1.useEffect)(() => {
        if (!restored) {
            if (defaultSize) {
                dispatchUpdateWidgetSize({
                    widgetName,
                    size: defaultSize,
                });
            }
            if (defaultPosition) {
                dispatchUpdateWidgetPosition({
                    widgetName,
                    position: defaultPosition,
                });
            }
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (rndRef.current) {
            rndRef.current.updatePosition(position);
            rndRef.current.updateSize(size);
        }
    }, [show, size, position, rndRef.current]);
    const widgetLiftUpHandler = () => {
        dispatchLiftUpWidget(widgetName);
    };
    const resizeHandler = (e, d, r, delta, newPosition) => {
        dispatchUpdateWidgetSize({
            widgetName,
            size: {
                height: size.height + delta.height,
                width: size.width + delta.width,
            },
        });
        dispatchUpdateWidgetPosition({
            widgetName,
            position: newPosition,
        });
    };
    const dragHandler = (e, delta) => {
        const deltaPosition = {
            x: delta.x,
            y: delta.y,
        };
        dispatchUpdateWidgetPosition({
            widgetName,
            position: deltaPosition,
        });
    };
    const getCurrentWidgetStateValue = () => {
        const localStorageKey = `${widgetName}-shape`;
        const currentValRaw = localStorage.getItem(localStorageKey);
        if (currentValRaw) {
            return JSON.parse(currentValRaw);
        }
        const defaultWidgetState = {
            position: defaultPosition,
            restored: false,
            show: false,
            size: defaultSize,
        };
        return defaultWidgetState;
    };
    const handleWidgetPositionScope = () => {
        var _a;
        const currentState = getCurrentWidgetStateValue();
        const currentElement = (_a = rndRef.current) === null || _a === void 0 ? void 0 : _a.getSelfElement();
        const parentElement = currentElement === null || currentElement === void 0 ? void 0 : currentElement.parentElement;
        const parentRect = parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect();
        const childRect = currentElement === null || currentElement === void 0 ? void 0 : currentElement.getBoundingClientRect();
        if (childRect && parentRect && currentState) {
            const localStorageKey = `${widgetName}-shape`;
            const isCrossing = childRect.right > parentRect.right;
            if (isCrossing && (parentElement === null || parentElement === void 0 ? void 0 : parentElement.clientWidth)) {
                if (parentElement.clientWidth > childRect.width) {
                    const newPosition = { x: parentElement.clientWidth - childRect.width, y: currentState.position.y };
                    localStorage.setItem(localStorageKey, JSON.stringify(Object.assign(Object.assign({}, currentState), { position: newPosition })));
                    dispatchUpdateWidgetPosition({
                        widgetName,
                        position: newPosition,
                    });
                }
                else {
                    const newPosition = { x: 0, y: currentState.position.y };
                    localStorage.setItem(localStorageKey, JSON.stringify(Object.assign(Object.assign({}, currentState), { position: newPosition })));
                    dispatchUpdateWidgetPosition({
                        widgetName,
                        position: newPosition,
                    });
                }
            }
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', handleWidgetPositionScope);
        return () => window.removeEventListener('resize', handleWidgetPositionScope);
    }, []);
    (0, react_1.useEffect)(() => {
        // If there is a saved position for that widget and that is out of the scrope of the current window area this function will fix it
        setTimeout(() => {
            handleWidgetPositionScope();
        }, 0);
    }, [show]);
    if (!show) {
        return null;
    }
    return (react_1.default.createElement(react_rnd_1.Rnd, { ref: rndRef, bounds: "parent", className: Widget_module_scss_1.default['widget'], "data-active": isWidgetActive, dragHandleClassName: Widget_module_scss_1.default['widget-drag-area'], resizeHandleComponent: {
            bottomRight: react_1.default.createElement(WidgetResizeIcon_1.default, null),
        }, default: { x: position.x, y: position.y, width: size.width, height: size.height }, minWidth: (_a = minSize === null || minSize === void 0 ? void 0 : minSize.width) !== null && _a !== void 0 ? _a : consts_1.widgetMinWidth, minHeight: (_b = minSize === null || minSize === void 0 ? void 0 : minSize.height) !== null && _b !== void 0 ? _b : consts_1.widgetMinHeight, onResizeStart: widgetLiftUpHandler, onResizeStop: resizeHandler, onDragStop: dragHandler },
        react_1.default.createElement("div", { className: Widget_module_scss_1.default['widget-container'], onMouseDown: widgetLiftUpHandler },
            react_1.default.createElement("div", { className: Widget_module_scss_1.default['widget-drag-area'] },
                react_1.default.createElement("div", { style: { backgroundImage: `url(${assets_1.svgBasicDragIcon})` }, className: Widget_module_scss_1.default['widget-drag-area-icon'] })),
            react_1.default.createElement("div", { className: Widget_module_scss_1.default['widget-content'] }, children))));
}
exports.default = Widget;
